import { DefaultTransitionState } from './DefaultTransitionState';
import type { InteractionVisualStateRuntime } from './AbstractInteractionVisualState';
import type { Viewer } from '../../viewer/Viewer';

/**
 * 基准点模式视觉状态。
 *
 * 说明：
 * 1. 当前阶段沿用默认模式的高亮语义；
 * 2. 单独抽出基准点状态类，便于后续继续扩展 datum 轴、datum 点等专属视觉规则；
 * 3. 这样 `InteractionStateManager` 在 reference-point 模式下不再直接依赖默认状态类。
 */
export class ReferencePointTransitionState extends DefaultTransitionState {
    /**
     * @param runtime 视觉状态运行时。
     * @param viewer Viewer 实例。
     */
    public constructor(runtime: InteractionVisualStateRuntime, viewer: Viewer) {
        super(runtime, viewer);
    }
}
